var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGalgar2Ny01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 138.67 74.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "3.35 70.24 148.64 70.24 148.64 7 3.35 7 3.35 70.24"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 14.48,
    y1: 15.07,
    x2: 18.29,
    y2: 58.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 21.56,
    y1: 15.07,
    x2: 25.37,
    y2: 58.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 32.45,
    y1: 15.07,
    x2: 28.67,
    y2: 58.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 37.64,
    y1: 15.01,
    x2: 37.64,
    y2: 58.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 46.61,
    y1: 15.07,
    x2: 42.83,
    y2: 58.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 56.99,
    y1: 15.07,
    x2: 60.8,
    y2: 58.39
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "65.99 15.01 65.99 58.45 65.99 15.07"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 74.96,
    y1: 15.07,
    x2: 71.18,
    y2: 58.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 78.26,
    y1: 15.07,
    x2: 82.04,
    y2: 58.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 87.23,
    y1: 15.01,
    x2: 87.23,
    y2: 58.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 103.31,
    y1: 15.07,
    x2: 99.53,
    y2: 58.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 106.61,
    y1: 15.07,
    x2: 110.39,
    y2: 58.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 113.69,
    y1: 15.07,
    x2: 117.47,
    y2: 58.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 122.66,
    y1: 15.01,
    x2: 122.66,
    y2: 58.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 12.83,
    y1: 36.73,
    x2: 126.2,
    y2: 36.73
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalgar2Ny01);
export default __webpack_public_path__ + "static/media/galgar 2 ny-01.52bfcd9e8406e830c00e98411ffa42ec.svg";
export { ForwardRef as ReactComponent };